const styles = {
  control: (provided) => ({
    ...provided,
    borderRadius: 0,
    border: "2px solid #bdbdbd",
    fontSize: "1rem",
    fontWeight: "lighter",
    fontFamily: "Gill Sans, sans-serif",
    marginTop: "0.5rem !important",
    color: "gray !important"
  })
}

export default styles
